import { formatPrice } from '../../../../utils';
import { countryUK } from '../../utils';
import { css, type Theme } from '@emotion/react';

export const pricePerLitreStyle: (theme: Theme) => ReturnType<typeof css> = (theme: Theme) => css`
  font-size: 14px;
  color: #73767d;
  font-weight: 400;
  line-height: ${theme.fonts.lineHeightDefault};
  margin-left: 5px;
  display: inline-flex;
  align-self: end;
`;

type PricePerLitreProps = {
  pricePerLitre?: number;
  bottleVolume?: number;
  price?: number;
};

export const PricePerLitre = ({ pricePerLitre, bottleVolume, price }: PricePerLitreProps) => {
  if (!countryUK()) {
    return null;
  }

  // If price and bottleVolume are provided, calculate price per litre, otherwise use the provided pricePerLitre
  const calculatedPricePerLitre =
    price !== undefined && price !== null && bottleVolume !== undefined && bottleVolume !== null
      ? (price / bottleVolume) * 1000
      : pricePerLitre;

  if (calculatedPricePerLitre === undefined || calculatedPricePerLitre <= 0) {
    return null;
  }

  return (
    <span data-testid="price-per-litre" css={pricePerLitreStyle} className="price-per-litre">
      ({formatPrice(calculatedPricePerLitre)} per litre)
    </span>
  );
};
